// @flow

import {
  produce,
} from 'immer';
import {
  SELECT_NARROW_FILTER,
  SELECT_CHIP,
  RESET_INIT,
  TOGGLE_ADVANCE_OPTION,
  APPLY_ADVANCE_FILTER,
} from './actionTypes';
import type {
  SearchState,
} from './types';
import {
  initialState,
} from './constants';

const handleSelectedChips = (
  state: SearchState,
  data: *,
) => produce(state, (draft) => {
  const {
    selectedChips,
    showAdvanceOptions,
    selectedChipsAdvance,
  } = state;
  const {
    index,
    init,
  } = data;
  draft.init = init;
  if (showAdvanceOptions) {
    draft.selectedChipsAdvance = {
      ...selectedChipsAdvance,
      [index]: {
        ...selectedChipsAdvance[index],
        selected: init ? false : !selectedChipsAdvance[index].selected,
      },
    };
  } else {
    draft.selectedChips = {
      ...selectedChips,
      [index]: {
        ...selectedChips[index],
        selected: init ? false : !selectedChips[index].selected,
      },
    };
  }
});

const handleApplyAdvanceFilter = (
  state: SearchState,
) => produce(state, draft => {
  const {
    selectedChipsAdvance,
  } = state;
  draft.selectedChips = {
    ...selectedChipsAdvance,
  };
});
const handleShowAdvanceOptions = (
  state: SearchState,
) => produce(state, draft => {
  draft.selectedChipsAdvance = {
    ...state.selectedChips,
  };
  draft.showAdvanceOptions = !state.showAdvanceOptions;
});
const handleSelectedNarrowFilter = (
  state: SearchState,
  data: *,
) => produce(state, (draft) => {
  const {
    id,
    contextType,
    label,
    icon,
    numericId,
  } = data;
  const filter = {
    id,
    contextType,
    label,
    icon,
    numericId,
  };
  draft.selectedNarrowedFilter = { ...filter };
  draft.init = false;
});

const handleResetInit = (
  state: SearchState,
) => produce(state, (draft) => {
  draft.init = !state.init;
});
const searchReducer = (
  state: SearchState = initialState,
  action: *,
) => {
  switch (action.type) {
    case SELECT_CHIP:
      return handleSelectedChips(
        state,
        action.data,
      );
    case SELECT_NARROW_FILTER:
      return handleSelectedNarrowFilter(
        state,
        action.data,
      );
    case RESET_INIT:
      return handleResetInit(state);
    case TOGGLE_ADVANCE_OPTION:
      return handleShowAdvanceOptions(state);
    case APPLY_ADVANCE_FILTER:
      return handleApplyAdvanceFilter(state);
    default:
      return state;
  }
};

export default searchReducer;
